export default "__VITE_ASSET__2SSNEqb6__"